import { render, staticRenderFns } from "./ReportsWidget.vue?vue&type=template&id=01c681e2&"
import script from "./ReportsWidget.vue?vue&type=script&lang=js&"
export * from "./ReportsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportsWidget.vue?vue&type=style&index=0&id=01c681e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports